/**
 * Publishing Management Page - Buried Point Configuration
 * 埋点配置 - 发行管理页
 * 
 * ID Allocation:
 * - 100031: Publishing - Overview page
 * - 100032: Publishing - MKT Cost page
 * - 100033: Publishing - Publishing Business Headcount page
 * - 100034: Publishing - Publishing Project page
 * - Buttons: {pageId}001, {pageId}002, etc.
 */

const typeId = 'mgmt_pc_v2';
const source = 0;

// Overview Sub-tab (as a page view)
export const OverviewTab = {
  pageName: 'Publishing Management - Overview',
  pageId: '100031',
  pagePath: '/strategic/home?tab=publishing&subtitle=overview',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100031001',
      buttonName: 'Overview',
    },
    // Decision Point List button
    decisionPointList: {
      buttonId: '100031002',
      buttonName: 'Decision Point List',
    },
    // Gross Revenue Trend - View button
    grossRevenueTrendView: {
      buttonId: '100031003',
      buttonName: 'Gross Revenue Trend - View',
    },
    // Gross Revenue Trend - Line Chart button
    grossRevenueTrendLineChart: {
      buttonId: '100031004',
      buttonName: 'Gross Revenue Trend - Line Chart',
    },
    // Gross Revenue Trend - Bar Chart button
    grossRevenueTrendBarChart: {
      buttonId: '100031005',
      buttonName: 'Gross Revenue Trend - Bar Chart',
    },
    // Gross Revenue Trend - Table button
    grossRevenueTrendTable: {
      buttonId: '100031006',
      buttonName: 'Gross Revenue Trend - Table',
    },
    // Gross Revenue Trend - Download button
    grossRevenueTrendDownload: {
      buttonId: '100031007',
      buttonName: 'Gross Revenue Trend - Download',
    },
    // Gross Revenue by Projects - Project Collapse/Expand
    grossRevenueByProjectsCollapse: {
      buttonId: '100031008',
      buttonName: 'Gross Revenue by Projects - Project Collapse',
    },
    // Gross Revenue by Projects - Edit button
    grossRevenueByProjectsEdit: {
      buttonId: '100031009',
      buttonName: 'Gross Revenue by Projects - Edit',
    },
    // Decision Points List - Edit button
    decisionPointsListEdit: {
      buttonId: '100031010',
      buttonName: 'Decision Points List - Edit',
    },
    // Notes - Edit button
    notesEdit: {
      buttonId: '100031011',
      buttonName: 'Notes - Edit',
    },
    // Month Picker (top filter)
    monthPicker: {
      buttonId: '100031012',
      buttonName: 'Month Picker',
    },
    // Show Events toggle button
    showEvents: {
      buttonId: '100031013',
      buttonName: 'Show Events',
    },
  },
};

// MKT Cost Sub-tab (as a page view)
export const MKTCostTab = {
  pageName: 'Publishing Management - MKT Cost',
  pageId: '100032',
  pagePath: '/strategic/home?tab=publishing&subtitle=mktCost',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100032001',
      buttonName: 'MKT Cost',
    },
    // MKT Cost by Projects - Project Collapse/Expand
    mktCostByProjectsCollapse: {
      buttonId: '100032002',
      buttonName: 'MKT Cost by Projects - Project Collapse',
    },
    // MKT Cost by Projects - Edit button
    mktCostByProjectsEdit: {
      buttonId: '100032003',
      buttonName: 'MKT Cost by Projects - Edit',
    },
    // MKT Budget Application Calendar - Edit button
    mktBudgetApplicationCalendarEdit: {
      buttonId: '100032004',
      buttonName: 'MKT Budget Application Calendar - Edit',
    },
    // Notes - Edit button
    notesEdit: {
      buttonId: '100032005',
      buttonName: 'Notes - Edit',
    },
    // Month Picker (top filter)
    monthPicker: {
      buttonId: '100032006',
      buttonName: 'Month Picker',
    },
  },
};

// Publishing Business Headcount Sub-tab (as a page view)
export const PublishingHeadcountTab = {
  pageName: 'Publishing Management - Publishing Business Headcount',
  pageId: '100033',
  pagePath: '/strategic/home?tab=publishing&subtitle=publishingHeadcount',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100033001',
      buttonName: 'Publishing Business Headcount',
    },
    // Headcount Trend - Bar Chart button
    headcountTrendBarChart: {
      buttonId: '100033002',
      buttonName: 'Headcount Trend - Bar Chart',
    },
    // Headcount Trend - Table button
    headcountTrendTable: {
      buttonId: '100033003',
      buttonName: 'Headcount Trend - Table',
    },
    // Headcount Trend - Download button
    headcountTrendDownload: {
      buttonId: '100033004',
      buttonName: 'Headcount Trend - Download',
    },
    // Project Headcount Table - Project Collapse/Expand
    projectHeadcountTableCollapse: {
      buttonId: '100033005',
      buttonName: 'Project Headcount Table - Project Collapse',
    },
    // Project Headcount Table - Edit button
    projectHeadcountTableEdit: {
      buttonId: '100033006',
      buttonName: 'Project Headcount Table - Edit',
    },
    // Notes - Edit button
    notesEdit: {
      buttonId: '100033007',
      buttonName: 'Notes - Edit',
    },
    // Appendix Notes - Edit button
    appendixNotes: {
      buttonId: '100033008',
      buttonName: 'Appendix Notes - Edit',
    },
    // Month Picker (top filter)
    monthPicker: {
      buttonId: '100033009',
      buttonName: 'Month Picker',
    },
  },
};

// Publishing Project Sub-tab (as a page view)
export const PublishingProjectTab = {
  pageName: 'Publishing Management - Publishing Project',
  pageId: '100034',
  pagePath: '/strategic/home?tab=publishing&subtitle=publishingProject',
  common: {
    source,
    typeId,
  },
  button: {
    // Tab click button
    tabClick: {
      buttonId: '100034001',
      buttonName: 'Publishing Project',
    },
    // Project Select (in GameSelect dropdown)
    projectSelect: {
      buttonId: '100034002',
      buttonName: 'Project Select',
    },
    // Dashboard Link Click
    dashboardLinkClick: {
      buttonId: '100034003',
      buttonName: 'Dashboard Link Click',
    },
    // Publishing Review Updates - Edit button
    publishingReviewUpdatesEdit: {
      buttonId: '100034004',
      buttonName: 'Publishing Review Updates - Edit',
    },
    // Appendix Notes - Edit button
    appendixNotes: {
      buttonId: '100034005',
      buttonName: 'Appendix Notes - Edit',
    },
    // Month Picker (top filter)
    monthPicker: {
      buttonId: '100034006',
      buttonName: 'Month Picker',
    },
  },
};

// Export all configs
export default {
  overview: OverviewTab,
  mktCost: MKTCostTab,
  publishingHeadcount: PublishingHeadcountTab,
  publishingProject: PublishingProjectTab,
};

